import { DOMAttributes, useEffect, useRef } from 'react';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';

type CustomElement<T> = Partial<T & DOMAttributes<T> & { children: any; ref: any }>;

interface WherebyEmbedElement extends HTMLElement {
  room: string;
  displayName?: string;
  metadata?: string;
  minimal?: 'on' | 'off';
  leaveButton?: 'on' | 'off';
  screenshare?: 'on' | 'off';
  pipButton?: 'on' | 'off';
  people?: 'on' | 'off';
  floatSelf?: 'on' | 'off';
  recording?: 'on' | 'off';
  avatarUrl?: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'whereby-embed': CustomElement<WherebyEmbedElement>;
    }
  }
}

interface WherebyEmbedProps {
  room: string;
  onLeave(): void;
}

export const WherebyEmbed = ({ room, onLeave }: WherebyEmbedProps) => {
  const { state } = useApplicationContext();
  const embedRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const { current } = embedRef;
    if (!embedRef.current) {
      return;
    }

    function handleLeave() {
      onLeave();
    }

    embedRef.current.addEventListener('leave', handleLeave);

    return () => {
      current?.removeEventListener('leave', handleLeave);
    };
  }, [onLeave]);

  return (
    <whereby-embed
      ref={embedRef}
      room={`${room}`}
      displayName={state.user?.name}
      minimal="on"
      metadata={state.user?.id}
      avatarUrl={state.user?.profileUrl}
      leaveButton="on"
      screenshare="on"
      people="off"
      recording="off"
    />
  );
};
